
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lupa-password/konfirmasi-username",
      function () {
        return require("private-next-pages/lupa-password/konfirmasi-username.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lupa-password/konfirmasi-username"])
      });
    }
  